import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: 'app-comman-header',
  templateUrl: './comman-header.component.html',
  styleUrls: ['./comman-header.component.css']
})
export class CommanHeaderComponent implements OnInit {
  username: string; FirmName: string; loginlist: any = [];
  FirmCtgType: string;

  constructor(private router: Router, private MsgService: ToastrService) { }

  ngOnInit() {
    this.GetSessionValue();
  }
  OnHelp() {
    //document.location.href = '';
    window.open('http://oswalapp.centralindia.cloudapp.azure.com/JMCEauctionWeb/assets/eauctionhelp.pdf');
    // const link = document.createElement('a');
    // link.target = '_blank';
    // link.href = 'http://oswalapp.centralindia.cloudapp.azure.com/JMCEauctionAPI/Documents/AuctionPDF/72_1.pdf';
    // link.setAttribute('visibility', 'hidden');
    // link.click();


  }
  OnUserHelp() {
    window.open('http://oswalapp.centralindia.cloudapp.azure.com/JMCEauctionWeb/assets/eauctionhelp.pdf');

  }
  OnUserHelpMob() {
    window.open('http://oswalapp.centralindia.cloudapp.azure.com/JMCEauctionWeb/assets/eauctionhelp.pdf');

  }

  GetSessionValue() {
    try {
      if (sessionStorage.getItem('loginSession') != null) {

        // *************************************change 16012020 *****************************
        let ResponseDecrpt = sessionStorage.getItem('loginSession');
        this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
        this.username = this.loginlist[0]['UserName'];
        this.FirmName = this.loginlist[0]['FullName'];
        this.FirmCtgType = this.loginlist[0]['FirmCtgType'];
        // ****************end*************************************************

        //let res = JSON.parse(sessionStorage.getItem('loginSession'));
        // this.username = this.loginlist[0]['UserName'];
        // this.FirmName = this.loginlist[0]['FullName'];
      }
    }
    catch (err) {
      console.log(err);
    }
  }

  NavbarOpen() {
    if ($(".nav-side-menu").hasClass("navbaropen")) {
      $('.nav-side-menu').removeClass('navbaropen');
      $('.menu-close').removeClass('menu-close-in');
    }
    else {
      $('.nav-side-menu').addClass('navbaropen');
      $('.menu-close').addClass('menu-close-in');
    }
    return false;
  }
  logout() {
    sessionStorage.clear();
    this.MsgService.warning('Logout');
    this.router.navigate(['/']);
  }


}
